import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { AdminShell } from '../components/admin/AdminShell';
import { adminApi, apiError } from '../lib/adminApi';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    setInfo('');
    try {
      if (mode === 'login') {
        await adminApi.post('/auth/login', { email, password });
        navigate('/admin');
      } else {
        const { data } = await adminApi.post('/auth/forgot-password', { email });
        setInfo(data.message);
      }
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AdminShell title="Panel de administración">
      <Card className="bg-white border-tan shadow-md">
        <CardContent className="p-6 md:p-8">
          <h1 className="text-xl font-bold text-cafe-noir mb-6">
            {mode === 'login' ? 'Iniciar sesión' : 'Establecer o restablecer contraseña'}
          </h1>
          <form onSubmit={submit} className="space-y-4">
            <Input data-testid="admin-email-input" type="email" required placeholder="correo@bullishaccounting.com"
              value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white border-tan" />
            {mode === 'login' && (
              <Input data-testid="admin-password-input" type="password" required placeholder="Contraseña"
                value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white border-tan" />
            )}
            {error && <p data-testid="admin-login-error" className="text-sm text-red-700">{error}</p>}
            {info && <p data-testid="admin-login-info" className="text-sm text-kombu-green">{info}</p>}
            <Button data-testid="admin-login-submit" type="submit" disabled={busy}
              className="w-full bg-kombu-green hover:bg-kombu-green-dark text-white">
              {busy ? 'Procesando...' : mode === 'login' ? 'Entrar' : 'Enviar enlace'}
            </Button>
          </form>
          <button data-testid="admin-toggle-mode" type="button"
            onClick={() => { setMode(mode === 'login' ? 'forgot' : 'login'); setError(''); setInfo(''); }}
            className="mt-5 text-sm text-moss-green hover:text-kombu-green underline">
            {mode === 'login' ? '¿Primera vez u olvidaste tu contraseña?' : 'Volver a iniciar sesión'}
          </button>
        </CardContent>
      </Card>
    </AdminShell>
  );
}
